<h1 mat-dialog-title>Preferences</h1>
@if (preferences$ | async; as preferences) {
    <div mat-dialog-content>
        @if (user$ | async; as user) {
            <div class="user-header">
                <img src="{{ user.email | identicon | async }}" class="user-icon" />
                <div class="flex column align-items-start name">
                    <div class="flex">{{ user.name | titlecase }}
                    <button class="edit-user-button" (click)="userDetail(user)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    </div>
                    <div class="flex headline">{{ user.email }} [{{ Role[user.getRole()] }}]</div>
                </div>
            </div>
        }
        <form [formGroup]="form">
            <mat-tab-group>
                <mat-tab label="Streams">
                    <h3>Thumbnails</h3>
                    <mat-checkbox formControlName="use_large_thumbnails"
                        >Use Large Thumbnails</mat-checkbox
                    >
                    <span matListItemLine class="muted"
                        >This is sometimes helpful for meeting room displays.</span
                    >
                    <mat-slider max="10" [discrete]="true">
                        <input matSliderThumb formControlName="thumbnail_padding" />
                    </mat-slider>
                    <span matListItemLine class="muted"
                        >Pad thumbnails so there is some distance between images</span
                    >
                    <h3>Slack Authorization</h3>
                    <p>
                        Enable FrogEye to post messages to slack on your behalf when you upload new
                        content
                    </p>
                    <p>
                        You can view your current Slack authorizations
                        <a href="https://api.slack.com/tokens" target="_blank">here</a>
                    </p>
                    @if (preferences.slack?.installed) {
                        <div class="flex column align-start justify-start align-items-start">
                            <button mat-button color="warn" (click)="uninstallSlack()">
                                <mat-icon>delete</mat-icon>
                                Uninstall Slack App
                            </button>
                            <a mat-button color="primary" href="/api/slack/authorize">
                                <mat-icon>refresh</mat-icon>
                                Re-Install Slack App</a
                            >
                        </div>
                    } @else {
                        <a mat-flat-button color="primary" href="/api/slack/authorize">Install Slack App</a>
                    }
                    @if (preferences.slack?.installed) {
                        <h3>Slack Messages</h3>
                        <p>Which Slack channel should FrogEye post to?</p>
                        <div class="flex column align-items-start">
                            <mat-form-field appearance="fill">
                                <mat-select
                                    formControlName="slack_channel"
                                    (selectionChange)="setName($event.value)"
                                >
                                    <mat-select-trigger>
                                        {{ slackChannelName }}
                                    </mat-select-trigger>
                                    @for (channel of slackChannels$ | async; track channel) {
                                        <mat-option [value]="channel.id">
                                            <mat-icon>{{
                                                channel.is_private ? "lock" : "tag"
                                            }}</mat-icon>
                                            {{ channel.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <button mat-flat-button (click)="testSlack()">Send Test Message</button>
                        </div>
                    }
                    <p></p>
                </mat-tab>
                <mat-tab label="Viewer">
                    <h3>Background Color</h3>
                    <frog-swatch-picker formControlName="viewer_background"></frog-swatch-picker>
                    <h3>Minimap</h3>
                    <p>Show or hide the minimap in the asset viewer</p>
                    <mat-checkbox formControlName="show_minimap">Show Minimap</mat-checkbox>
                    <h3>Anti-Alias</h3>
                    <p>Smooth the image as you zoom in and out</p>
                    <mat-checkbox formControlName="antialias">Enable anti-aliasing</mat-checkbox>
                    <p>&nbsp;</p>
                </mat-tab>
                <mat-tab label="Notifications">
                    <h3>Which notification would you like to receive?</h3>
                    <div>
                        <mat-checkbox formControlName="notifications_comments">Comments</mat-checkbox>
                        <br />
                        <mat-checkbox formControlName="notifications_mentions">Mentions</mat-checkbox>
                        <br />
                        <mat-checkbox formControlName="notifications_likes">Likes</mat-checkbox>
                    </div>

                    <h3>How do you want to be notified?</h3>
                    <div>
                        <mat-checkbox formControlName="notifications_via_email">Email</mat-checkbox>
                        <br />
                        @if (preferences.slack?.installed) {
                        <mat-checkbox formControlName="notifications_via_slack">Slack</mat-checkbox>
                        }
                        @else {
                        <mat-checkbox [disabled]="true" [checked]="false">Slack</mat-checkbox>
                        <br />
                        <a mat-flat-button color="primary" href="/api/slack/authorize">Install Slack App</a>
                        }
                    </div>
                    <p>&nbsp;</p>
                </mat-tab>
            </mat-tab-group>
        </form>
    </div>
}
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button mat-dialog-close color="primary" (click)="save()">Save</button>
</div>
